import { render, staticRenderFns } from "./details_btn.vue?vue&type=template&id=7dd4a776&lang=pug&"
import script from "./details_btn.vue?vue&type=script&lang=js&"
export * from "./details_btn.vue?vue&type=script&lang=js&"
import style0 from "./details_btn.vue?vue&type=style&index=0&id=7dd4a776&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports